import axios from 'axios'
import { Toast,Dialog } from 'mand-mobile'
import CurrentUser from "./current-user";

const init = function () {
    console.log('init');
    console.log(process.env.VUE_APP_API_BASE_URL);
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

    headers();
    errors();
};

function headers() {
    axios.defaults.headers.common['Accept'] = 'application/json';
}

function errors() {
    axios.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    }, function (error) {
        const {status} = error.response;
        Toast.hide();
        console.log(status);

        switch (status) {
            case 401:
                CurrentUser.getInstance().logout();
                return alertError("登录信息失效，请刷新或者重新打开页面", error);
                break;

            case 403:
                Toast.failed("暂无权限");
                break;

            case 404:
                Toast.failed("数据不存在或者已被删除");
                break;

            case 422:
                return alertError(parseError(error.response.data), error);
                break;

            default:
                Toast.failed("服务器错误，请稍候重试");
                break;
        }

        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    });
}

function alertError(msg, error) {
    return new Promise(function (resolve, reject) {
        Dialog.alert({
            title: '错误',
            content: msg,
            confirmText: '确定',
            onConfirm: () => {
                return reject(error);
            },
        });
    })

}

function parseError(msg) {
    if(msg.errors) {
        const key = Object.keys(msg.errors)[0];

        return msg.errors[key][0];
    }

    return msg.message;
}

export default {
    init: init
};